import { LocalStorageKeys } from "@service/LocalStorageService";

export const isUserFromAd = () => {
    return window.localStorage.getItem(LocalStorageKeys.TrafficSource) == "ad";
};
